import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Row, Col } from 'react-flexbox-grid';
import CircularProgress from 'material-ui/CircularProgress';
import Subheader from 'material-ui/Subheader';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import PanelMessage from 'components/panels/PanelMessage';
import {
  setEmployeeYear,
  setManagerYear,
  setEmployee,
} from 'actions/Appraisal';
import styles from 'styles/AppraisalList';
import AppraisalItem from './AppraisalItem';
import getAppraisalTitle from '../containers/utils/getAppraisalTitle';

const AppraisalList = ({
  appraisals,
  onClick,
  loading,
  isManager,
  yearOptions,
  year,
  employee,
  dispatch,
  valuesByKey,
}) => {
  const appraisalTitle = getAppraisalTitle(valuesByKey);

  const setYear = (val) => {
    const method = isManager ? setManagerYear : setEmployeeYear;
    dispatch(method(val));
  };

  const handleEmployee = (value) => {
    dispatch(setEmployee(value));
  };

  const employeesMap = appraisals.reduce((acc, a) => acc.set(a.EmployeeMasterID, a.EmployeeName), new Map());
  const employees = [];
  employeesMap.forEach((value, key) => employees.push({ name: value, id: key }));

  const filter = a =>
    (!year || new Date(a.FinalAppraisalDate).getFullYear() === year)
    && (!employee || a.EmployeeMasterID === employee);

  const filteredAppraisals = appraisals
    .filter(filter)
    .map(a => <AppraisalItem appraisal={a} isManager={isManager} onClick={onClick} key={a.PMAppraisalID} />);

  const found = appraisals.some(filter);

  if (loading) return <CircularProgress />;

  return (
    <Col xs={12} sm={12} md={10} mdOffset={1}>
      <Subheader style={styles.header}><FormattedMessage id={appraisalTitle} /></Subheader>
      <Row middle="xs" center="xs">
        <Col xs style={{ textAlign: 'left' }}>
          <SelectField
            floatingLabelText={<FormattedMessage id="appraisal.select.year" />}
            value={year}
            onChange={(a, b, value) => setYear(value)}
          >
            <MenuItem key={0} value={0} primaryText={' '} />
            {yearOptions.map(y =>
              <MenuItem key={y} value={y} primaryText={y} />)
            }
          </SelectField>
          <span style={{ padding: '10px' }} />
          {isManager &&
            <SelectField
              style={{ width: '400px' }}
              floatingLabelText={<FormattedMessage id="appraisal.select.employee" />}
              value={employee}
              onChange={(a, b, value) => handleEmployee(value)}
            >
              <MenuItem key={0} value={0} primaryText={' '} />
              {employees.map(e =>
                <MenuItem key={e.id} value={e.id} primaryText={e.name} />)
              }
            </SelectField>
          }
          {!found &&
            <PanelMessage type="info" iconName="info" message={<FormattedMessage id="appraisal.noAppraisal" values={{ year }} />} />
          }
          {filteredAppraisals}
        </Col>
      </Row>
    </Col>
  );
};

AppraisalList.propTypes = {
  appraisals: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isManager: PropTypes.bool.isRequired,
  yearOptions: PropTypes.array.isRequired,
  year: PropTypes.number.isRequired,
  employee: PropTypes.number,
  dispatch: PropTypes.func.isRequired,
  valuesByKey: PropTypes.object,
};

const mapStateToProps = state => ({
  valuesByKey: state.WebValuesReducer.valuesByKey,
});

export default connect(mapStateToProps)(AppraisalList);



// WEBPACK FOOTER //
// ./src/components/AppraisalList.js